import { useRef } from 'react'

export const useDebounced = <TArg>(cb: (arg: TArg) => void, ms: number) => {
  const timeout = useRef(0)
  return (v: TArg) => {
    window.clearTimeout(timeout.current)

    timeout.current = window.setTimeout(cb, ms, v)
  }
}
